import styles from './styles.scss'
import { BrowserRouter as Router, Routes, Route}
    from 'react-router-dom'
import { useState, createContext, useEffect } from 'react'
import { ToastContainer } from 'react-toastify'

import NavMenu from './components/NavMenu'
import Header from "./components/Header"
import Footer from "./components/Footer"

import Home from './pages/Home'
import Event from './pages/Event'
import Result from './pages/Result'
import Document from './pages/Document'
import Auth from './pages/Auth'
import ApplyToRace from './pages/ApplyToRace'
import Notfound from './pages/NotFound'
import LangProvider from './components/LangProvider'
import DialogProvider from './components/DialogProvider'
import AuthProvider from './components/AuthProvider'

function App() {

  const [menuOpen, setMenuOpen] = useState(false)

  function handleMenuState(){
    setMenuOpen(!menuOpen)
  }

  return (
    <Router>
      <AuthProvider>
      <LangProvider>
      <DialogProvider>
        <div id="main-wrapper" className={menuOpen ? "menu-open" : ""}>
          <NavMenu menuHandler={handleMenuState} menuOpen={menuOpen}/>
          <div id="page-wrapper">
            <div id="page-blocker" className={menuOpen ? "page-blocked" : ""} onClick={() => handleMenuState()}></div>
            <div className="page-content">
              <Header menuHandler={handleMenuState} menuOpen={menuOpen}/>
              <Routes path={"/"}>
                <Route index={true} element={<Home />} />
                <Route path='event/:id' element={<Event />} />
                <Route path='result/:id' element={<Result />} />
                <Route path='auth' element={<Auth/>} />
                <Route path='apply' element={<ApplyToRace/>} />
                <Route path='document/:path' element={<Document/>}></Route>
                <Route path='*' element={<Notfound />}/>
              </Routes>
              <div id="stretcher"></div>
              <Footer />
            </div>
          </div>
        </div>
      </DialogProvider>
      </LangProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
